import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export default makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',

      '&$vertical': {
        flexDirection: 'row',
        columnGap: theme.spacing(1.5),
        '& $label': {
          fontSize: theme.typography.pxToRem(12),
          lineHeight: theme.typography.pxToRem(16),
          fontWeight: theme.typography.fontWeightRegular,
        },
        '& $button': {
          marginTop: 0,
          fontSize: theme.typography.pxToRem(14),
          padding: theme.spacing(1, 2),
          height: 'unset',
        },
      },
    },
    button: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(1.5, 6),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium,
      height: 48,
    },
    vertical: {},
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.success.active,
    },
  }),
  { name: 'BusinessBookDemoButton' }
);
